import { connect } from "react-redux";
import SearchableCompanyInfiniteListView from "components/infinite-listview/searchable-companies";
import { IStore } from "reducers";

const mapStateToProps = (state: IStore, ownProps: any) => ({
    watermarking: state.watermarking?.payload,
    ...ownProps,
});

export default connect(mapStateToProps, null)(SearchableCompanyInfiniteListView);
